export const canvasProvider = 'Canvas'
export const cleverProvider = 'Clever'
export const googleProvider = 'Google'
export const classlinkProvider = 'Classlink'
export const nycpsProvider = 'NYCPS'
export const canvasClassroomProvider = 'Canvas'
export const cleverClassroomProvider = 'Clever'
export const googleClassroomProvider = 'Google Classroom'
export const classlinkClassroomProvider = 'Classlink'
export const nycpsClassroomProvider = 'NYC Public Schools'
export const classroomProviders = [canvasClassroomProvider, cleverClassroomProvider, googleClassroomProvider, classlinkClassroomProvider, nycpsClassroomProvider]

const importClassroomsEventName = (provider: string) => `${provider.toLowerCase()}-classroom-students-imported`
const importClassroomsPath = (provider: string) => `/${provider.toLowerCase()}_integration/teachers/import_classrooms`
const importStudentsEventName = (provider: string) => `${provider.toLowerCase()}-classroom-students-imported`
const importStudentsPath = (provider: string) => `/${provider.toLowerCase()}_integration/teachers/import_students`
const retrieveClassroomsEventName = (provider: string) => `${provider.toLowerCase()}-classrooms-retrieved`
const retrieveClassroomsPath = (provider: string) => `/${provider.toLowerCase()}_integration/teachers/retrieve_classrooms`

export const providerConfigLookup = {
  [canvasProvider]: {
    importClassroomsEventName: importClassroomsEventName(canvasProvider),
    importClassroomsPath: importClassroomsPath(canvasProvider),
    importStudentsEventName: importStudentsEventName(canvasProvider),
    importStudentsPath: importStudentsPath(canvasProvider),
    isCanvas: true,
    retrieveClassroomsEventName: retrieveClassroomsEventName(canvasProvider),
    retrieveClassroomsPath: retrieveClassroomsPath(canvasProvider),
    title: canvasClassroomProvider,
  },
  [cleverProvider]: {
    importClassroomsEventName: importClassroomsEventName(cleverProvider),
    importClassroomsPath: importClassroomsPath(cleverProvider),
    importStudentsEventName: importStudentsEventName(cleverProvider),
    importStudentsPath: importStudentsPath(cleverProvider),
    isClever: true,
    retrieveClassroomsEventName: retrieveClassroomsEventName(cleverProvider),
    retrieveClassroomsPath: retrieveClassroomsPath(cleverProvider),
    title: cleverClassroomProvider,
  },
  [googleProvider]: {
    importClassroomsEventName: importClassroomsEventName(googleProvider),
    importClassroomsPath: importClassroomsPath(googleProvider),
    importStudentsPath: importStudentsPath(googleProvider),
    importStudentsEventName: importStudentsEventName(googleProvider),
    isGoogle: true,
    retrieveClassroomsPath: retrieveClassroomsPath(googleProvider),
    retrieveClassroomsEventName: retrieveClassroomsEventName(googleProvider),
    title: googleClassroomProvider,
  },
  [classlinkProvider]: {
    importClassroomsEventName: importClassroomsEventName(classlinkProvider),
    importClassroomsPath: importClassroomsPath(classlinkProvider),
    importStudentsEventName: importStudentsEventName(classlinkProvider),
    importStudentsPath: importStudentsPath(classlinkProvider),
    isClassLink: true,
    retrieveClassroomsEventName: retrieveClassroomsEventName(classlinkProvider),
    importsStudents: false, // Classlink rosters are synced for the teacher; there is no per-class re-import
    retrieveClassroomsPath: undefined, // Classlink classrooms are imported through a different flow
    title: classlinkClassroomProvider,
  },
  [nycpsProvider]: {
    // NYC Public Schools classes and rosters are synced by Quill from the district's rostering API, so the
    // teacher imports neither classes nor students and there are no import paths or events.
    importsClassrooms: false,
    importsStudents: false,
    retrieveClassroomsPath: undefined,
    title: nycpsClassroomProvider,
  }
}

// A classroom carries its provider's title (Classroom#provider on the server), not the user-provider key.
export const providerConfigForClassroom = (classroomProvider: string) => Object.values(providerConfigLookup).find((config: any) => config.title === classroomProvider)

export const teacherImportsStudents = (classroomProvider: string) => (providerConfigForClassroom(classroomProvider) as any)?.importsStudents !== false

